import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { apiError } from "../api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex bg-[#0A192F]">
      <div className="hidden lg:flex flex-1 relative">
        <img src="https://images.pexels.com/photos/4487383/pexels-photo-4487383.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt="Warehouse" className="absolute inset-0 w-full h-full object-cover opacity-40" />
        <div className="relative z-10 flex flex-col justify-end p-12">
          <h1 className="text-4xl font-bold text-white tracking-tight leading-tight" style={{ fontFamily: "Outfit" }}>
            Perfect invoices.<br />Zero shipment rejections.
          </h1>
          <p className="text-slate-300 mt-4 max-w-md">GST-compliant invoicing with E-Invoice &amp; E-Way Bill for Amazon, Flipkart, Blinkit and Firstcry shipments.</p>
        </div>
      </div>
      <div className="w-full lg:w-[460px] flex items-center justify-center p-6 bg-white">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5">
          <div className="flex items-center gap-3 mb-8">
            <img src="/logo.png" alt="StarAndDaisy" data-testid="login-logo" className="h-14 object-contain" />
            <div>
              <div className="font-bold text-lg tracking-tight" style={{ fontFamily: "Outfit" }}>SND Invoice-Gen</div>
              <div className="text-[10px] uppercase tracking-widest text-slate-500">GST Compliance Suite</div>
            </div>
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider text-slate-600">Email</label>
            <input data-testid="login-email-input" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5 w-full border border-slate-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#0047AB]/20 focus:border-[#0047AB]"
              placeholder="you@company.com" />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider text-slate-600">Password</label>
            <input data-testid="login-password-input" type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5 w-full border border-slate-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#0047AB]/20 focus:border-[#0047AB]"
              placeholder="••••••••" />
          </div>
          {error && <div data-testid="login-error" className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{error}</div>}
          <button data-testid="login-submit-btn" disabled={busy}
            className="w-full bg-[#0047AB] hover:bg-[#003380] text-white font-semibold rounded-lg py-2.5 text-sm transition-colors duration-200 disabled:opacity-60">
            {busy ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
